export type TvSeasonSummary = {
  season_number: number;
  name: string;
  episode_count?: number;
  air_date?: string | null;
  overview?: string;
  poster_path?: string | null;
  id?: number;
};

export function sortTvSeasons<T extends { season_number: number }>(
  seasons: T[],
): T[] {
  return [...seasons].sort((a, b) => a.season_number - b.season_number);
}

export function formatSeasonLabel(season: {
  season_number: number;
  name?: string | null;
}): string {
  const trimmed = (season.name ?? "").trim();
  if (trimmed.length > 0) {
    return trimmed;
  }
  if (season.season_number === 0) {
    return "Specials";
  }
  return `Season ${season.season_number}`;
}

export function truncateEpisodeOverview(
  text: string | null | undefined,
  maxLen = 160,
): string {
  if (!text) {
    return "";
  }
  const t = text.trim();
  if (t.length <= maxLen) {
    return t;
  }
  return `${t.slice(0, maxLen).trimEnd()}…`;
}
